import api from '@/api'
import $bus from '@/utils/bus'

const state = {
  isReported: false,
  reportNum: 0,
  storeId: null,
  planTime: '',
  // 全店铺已提报，全平台未提报
  isAllStoresReported: false,
  // 全平台已提报
  isAllReported: false,
  //单店铺是否能提报
  isStoreReported: false,
  //单店铺是已提报
  isStoreCanReported: false,
}

const mutations = {
  // 提报店铺数量
  SET_REPORTNUM: (state, data) => {
    state.reportNum = data
  },
  // 当前显示的店铺
  SET_STOREID: (state, data) => {
    state.storeId = data
  },
  // 当前tabs active 月份
  SET_PLANTIME: (state, data) => {
    state.planTime = data
  },
  SET_ISALLREPORTED: (state, data) => {
    state.isAllReported = data;
  },
  SET_ISSTOREREPORTED: (state, data) => {
    state.isStoreReported = data;
  },
  SET_ISSALREADY: (state, data) => {
    state.isStoreCanReported = data;
  },
  SET_ISALLSTORESREPORTED: (state, data) => {
    state.isAllStoresReported = data;
  },
}

const actions = {
  //全平台当月未提报数量
  async get_reportNum({commit}, num) {
    commit('SET_REPORTNUM', num)
  },
  // 当前显示月份是否已经全部提报
  get_isAllReported({commit}, data) {
    if(!state.storeId) return //当前用户没有店铺权限则不请求
    return api.smallHomeAppliances.storeReportStatus({fragment: [state.storeId ,state.planTime.replace('-','')]})
    .then(res=>{
      if(state.storeId == 0) {
        commit('SET_ISALLREPORTED', res.data.reportedStatus) //全平台已提报
        commit('SET_ISALLSTORESREPORTED', res.data.reportAble) //全平台可提报
      }else {
        commit('SET_ISSTOREREPORTED', res.data.reportAble)  //店铺可提报
        commit('SET_ISSALREADY', res.data.reportedStatus) //店铺已提报
      }
      $bus.$emit('smallOnSearch', null);
    })
  },
  set_storeId({commit},storeId) {
    commit('SET_STOREID', storeId);
  },
  set_planTime({commit}, planTime) {
    commit('SET_PLANTIME', planTime);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
